import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setErrorHandled } from './../../../redux/slice/const'
import { signoutRedirect } from './../../../services/userService'
import {
    Modal,
    Button,
    ModalBody,
    ModalHeader,
    ModalFooter
} from 'reactstrap'
function ErrorModal() {
    const { errorHandled } = useSelector(state => state.globalConst)
    const { user } = useSelector(state => state.tokens)
    const dispatch = useDispatch()
    const history = useHistory();

    const logIn = () => {
        if (user !== null) {
            console.log('cerrando sesion...')
            signoutRedirect();
        } else {
            dispatch(setErrorHandled(false))
            history.push('/login');
            location.reload();
        }
    }

    return (
        <div>
            <Modal
                isOpen={errorHandled}
                className="modal-dialog-centered"
                onClosed={logIn}
            >
                <ModalHeader
                >
                    Su sesión finalizó
                </ModalHeader>
                <ModalBody>
                    ¿Desea volver a iniciar sesión?
                </ModalBody>
                <ModalFooter>
                    <Button.Ripple
                        size='sm'
                        color="primary"
                        onClick={() => { logIn() }}
                    >
                        Iniciar
                    </Button.Ripple>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default ErrorModal